import { ShareToolFilter } from './types';

export const ALL = 'ALL';
export const MINE = 'MINE';
export const SUGGESTED = 'SUGGESTED';
export const STARRED = 'STARRED';

export const SHARE_TOOL_TYPE_TO_NAME_MAP: Record<ShareToolFilter, string> = {
  SLACK: 'Slack alerts',
  EMAIL: 'Email alerts',
  GOOGLE: 'Google sheets feeds',
  S3_BUCKETS: 'S3 bucket feeds',
  ZAPIER: 'Zapier',
};
